import { LocationMapper } from "./location.mapper";
import { Injectable } from "@angular/core";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { map } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { Location } from "./location.model";
import { IMaerskLocation } from "./maersk-location.model";

@Injectable()
export class LocationRepository extends CrudAbstractRepository {
  getMapper(): any {
    return LocationMapper.map;
  }

  getEndpoint(): string {
    return "location";
  }

  public saveAvailableOnline(model: Location): Observable<object> {
    return this.http.patch(
      `${environment.apiUrl}/${this.getEndpoint()}/${model.getId()}`,
      {
        availableOnline: model.availableOnline,
      },
    );
  }

  public search(query: string, locationKind: string): Observable<Location[]> {
    let params = new HttpParams().append("search", query);

    if (locationKind) {
      params = params.append("criteria[kind]", locationKind);
    }

    return this.http
      .get<Location[]>(`${environment.apiUrl}/${this.getEndpoint()}/list`, {
        params: params,
      })
      .pipe(map((response) => response.map(this.getMapper())));
  }

  public searchMaersk(
    cityName: string,
    country: string,
  ): Observable<IMaerskLocation[]> {
    let params = new HttpParams().append("cityName", cityName);
    params = params.append("countryCode", country);

    return this.http.get<IMaerskLocation[]>(
      `${environment.apiUrl}/${this.getEndpoint()}/maersk`,
      {
        params: params,
      },
    );
  }
}
